export default function () {
  const widgetName = 'eventCards';
  const widgetOpts = eventCardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (widgetData) {
      
      $(`#${widgetName} .card-widget-item`).each(function (x) {

        let buttonText = widgetData.items[x].Description;
        let buttonUrl = widgetData.items[x].URL;
        let newButtonElement = `<a href="${buttonUrl}" class="button">${buttonText}</a>`;

        $(this).find('.buttonwrap').remove();
        $(this).find('.card-widget-description').remove();

        if (buttonUrl != null) {
          $(this).append(newButtonElement);
          $(this).append('<div class="overlay"></div>');
        }
      })
    },

    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: [''],
    maxItemsVisible: 2,
    moreButton: {
      visible: true,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });

}